import { createContext } from 'react';

export default createContext({
  showModal: true,
  hideModal: true,
});
